import { CircularProgress } from "@material-ui/core";
import styles from "./ContainerLoadingWithBlurAnimatin.module.css";
const ContainerLoadingwithBlurEffect = () => {
  return (
    <div className={styles.loadingContainer}>
      <div
        className={`loading-background rounded-circle bg-white shadow p-2 d-flex justify-content-center align-items-center ${styles.absoluteCenter}`}
      >
        <CircularProgress
          className="rounded-circle"
          color="success"
          sx={{ fontSize: 10, color: "#002244" }}
          disableShrink
        />
      </div>
    </div>
  );
};

export default ContainerLoadingwithBlurEffect;
